module.exports = __webpack_public_path__ + "img/tv-jadran.a1193c55.png";